import { DEV } from "solid-js"
import { freeze } from "../util/Object"

const dijkstraDirectionsLowerCase = [
  's',
  'e',
  'n',
  'w',
] as const

if (DEV) {
  freeze(dijkstraDirectionsLowerCase)
}

export default dijkstraDirectionsLowerCase